import Vue from 'vue'

export const TICKET_GROUP = [
  {
    id: 6,
    name: 'Обращения от мастеров',
  },
  {
    id: 4,
    name: 'Отдел кадров',
  },
  {
    id: 3,
    name: 'Отдел качества',
  },
  {
    id: 1,
    name: 'Технический отдел (CRM, Pilki Master, Pilki Client)',
  },
  {
    id: 5,
    name: 'Центр обращений для партнеров (ФРАНШИЗА)',
  },
]

export const ADD_TICKET_AUTOCOMPLETES = [
  {
    type: 'client',
    noDataText: 'Введите имя клиента',
    requestRoute: Vue.config.modules.crm.api.users.search,
    getRequestParams: clientName => ({
      name: clientName,
      with: 'cityDistrict',
      search: `blocked_at:null`,
      searchFields: `blocked_at:1`,
      searchJoin: 'and',
    }),
    getItemsArray: ({
      data: {
        data: {
          items: { data },
        },
      },
    }) => data,
    formatItemName: item => Vue.prototype.$getText('App\\Models\\UserPhonePrefixPostfix', item),
    conditions: ({ newSearchString }) => newSearchString && newSearchString.indexOf('***') === -1,
  },
  {
    type: 'employer',
    noDataText: 'Введите имя сотрудника',
    requestRoute: Vue.config.modules.crm.api.employers.all,
    getRequestParams: employerName => ({
      search: `id:${employerName};blocked_at:null;`,
      searchFields: 'id:plastic:employer;blocked_at:1;',
      searchJoin: 'and',
      limit: 30,
      offset: 0,
    }),
    getItemsArray: ({
      data: {
        data: { items },
      },
    }) => items,
    formatItemName: item => Vue.prototype.$getText('App\\Models\\Employer', item),
    conditions: ({ newSearchString, oldSearchString }) => newSearchString && newSearchString !== oldSearchString,
  },
  {
    type: 'unit',
    noDataText: 'Введите название студии',
    requestRoute: Vue.config.modules.crm.api.units.all,
    getRequestParams: unitName => ({
      search: `name:${unitName};type:0`,
      searchFields: 'name:like;type:in',
      searchJoin: 'and',
      limit: 30,
      offset: 0,
    }),
    getItemsArray: ({
      data: {
        data: { items },
      },
    }) => items,
    formatItemName: item => item.name,
    conditions: ({ newSearchString, oldSearchString }) => newSearchString && newSearchString !== oldSearchString,
  },
  {
    type: 'booking',
    noDataText: 'Введите номер заявки',
    requestRoute: Vue.config.modules.crm.api.bookings.all,
    getRequestParams: bookingId => ({
      search: `id:${bookingId};`,
      searchFields: 'id:like;',
      orderBy: 'created_at',
      sortedBy: 'desc',
      searchJoin: 'and',
      limit: 30,
      offset: 0,
    }),
    getItemsArray: ({
      data: {
        data: { items },
      },
    }) => items,
    formatItemName: booking => {
      const bookingDate = Vue.prototype.$formatDate(booking.created_at, 'date')
      const bookingUnitName = booking.unit?.name ?? '-'

      return `${booking.id}, ${bookingDate}, ${bookingUnitName}`
    },
    conditions: ({ newSearchString, oldSearchString }) =>
      newSearchString && newSearchString !== oldSearchString && newSearchString.split(',').length === 1,
  },
]

export const TICKET_TABLE_HEADERS = [
  {
    text: '',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-unread',
    canHide: false,
  },
  {
    text: '№',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-id',
    canHide: false,
  },
  {
    text: 'Автор обращения',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-creator',
    canHide: false,
  },
  {
    text: 'Тема',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-subject',
    canHide: false,
  },
  {
    text: 'Срок выполнения',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-subject',
    canHide: false,
  },
  {
    text: 'Студия',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-unit',
    canHide: false,
  },
  {
    text: 'Статус',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-status',
    canHide: false,
  },
  {
    text: 'Дата создания',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-created_at',
    canHide: false,
  },
  {
    text: 'Обновлено',
    align: 'left',
    sortable: false,
    order: false,
    value: 'id',
    key: 'ticket-updated_at',
    canHide: false,
  },
]

export const TICKET_LIST_FILTERS_CONFIG = [
  {
    id: 0,
    itemText: 'name',
    label: 'Отдел',
    name: 'ticket_group_id',
    position: 0,
    type: '=',
    view: 0,
    getter: 'GETTER_TICKET_GROUP',
    value: 'id',
  },
  // {
  //   id: 1,
  //   itemText: 'title',
  //   label: 'Дата',
  //   name: 'date',
  //   position: 0,
  //   type: 'between',
  //   view: 0,
  //   value: ''
  // },
  {
    id: 6,
    itemText: 'text',
    label: 'Раздел',
    name: 'first_question_id',
    position: 3,
    type: '=',
    view: 0,
    getter: 'questionTickets/questionsSections',
    value: 'id',
  },
  {
    id: 7,
    itemText: 'text',
    label: 'Тема',
    name: 'parent_question_id',
    position: 2,
    type: '=',
    view: 0,
    getter: 'questionTickets/questionsTopics',
    value: 'parent_id',
  },
  {
    id: 2,
    itemText: 'name',
    label: 'Статус',
    name: 'status',
    position: 1,
    type: '=',
    view: 0,
    getter: 'GETTER_TICKET_STATUS',
    value: '',
  },
  {
    id: 4,
    itemText: 'name',
    label: 'Сотрудник',
    name: 'employer_id',
    position: 4,
    type: '=',
    view: 0,
    getter: 'employers',
    value: '',
  },
  {
    id: 5,
    itemText: 'name',
    label: 'Студия',
    name: 'unit_id',
    position: 5,
    type: '=',
    view: 0,
    getter: 'units',
    value: '',
  },
]

export const TICKET_STATUSES = [
  {
    id: '0',
    title: 'ASKED',
    name: 'Ожидает ответа',
    iconName: 'drafts',
    color: '',
    waiting: true,
  },
  {
    id: '5',
    title: 'PROCESS',
    name: 'В процессе решения',
    iconName: 'toys',
    color: '#84dde6',
    waiting: false,
  },
  {
    id: '2',
    title: 'RESOLVED',
    name: 'Вопрос решен',
    iconName: 'check',
    color: '#24a522',
    waiting: false,
  },
  // {
  //   id: '8',
  //   title: 'APPROVE_WAITING',
  //   name: 'На согласовании',
  //   iconName: 'hourglass_full',
  //   color: '',
  //   waiting: false,
  // },
  // {
  //   id: '9',
  //   title: 'APPROVED',
  //   name: 'Согласовано',
  //   iconName: 'hourglass_full',
  //   color: '#84dde6',
  //   waiting: false,
  // },
  // {
  //   id: '10',
  //   title: 'NOT_APPROVED',
  //   name: 'Не согласовано',
  //   iconName: 'hourglass_full',
  //   color: '#ed8a8a',
  //   waiting: false,
  // },
  {
    id: '7',
    title: 'REJECTED',
    name: 'Отклонен',
    iconName: 'cancel',
    color: '#ed8a8a',
    waiting: false,
  },
  {
    id: '3',
    title: 'STATUS_NEED_INFO',
    name: 'Необходима доп. информация',
    iconName: 'help',
    color: '#ed8a8a',
    waiting: false,
  },
  {
    id: '4',
    title: 'DUPLICATE',
    name: 'Дубликат',
    iconName: 'filter_2',
    color: '',
    waiting: false,
  },
  {
    id: '6',
    title: 'PROPOSAL',
    name: 'Предложение',
    iconName: 'emoji_objects',
    color: '',
    waiting: false,
  },
  {
    id: '1',
    title: 'ANSWERED',
    name: 'Получен ответ',
    iconName: 'email',
    color: '',
    waiting: false,
  },
]

export const LIMIT = 30
export const OFFSET = 0
export const ROOT_QUESTION_PARENT_ID = -1
